
namespace TabAurous.OMS {

    @Serenity.Decorators.registerClass()
    export class LedgerPostingDialog extends Serenity.EntityDialog<LedgerPostingRow, any> {
        protected getFormKey() { return LedgerPostingForm.formKey; }
        protected getIdProperty() { return LedgerPostingRow.idProperty; }
        protected getLocalTextPrefix() { return LedgerPostingRow.localTextPrefix; }
        protected getNameProperty() { return LedgerPostingRow.nameProperty; }
        protected getService() { return LedgerPostingService.baseUrl; }
        protected getDeletePermission() { return LedgerPostingRow.deletePermission; }
        protected getInsertPermission() { return LedgerPostingRow.insertPermission; }
        protected getUpdatePermission() { return LedgerPostingRow.updatePermission; }

        protected form = new LedgerPostingForm(this.idPrefix);

    }
}